import {Button, CircularProgress} from '@mui/material';
import {MouseEvent} from 'react';

import {AppNotification} from '../../types/notifications.types';
import {EmptyText, NotificationsList as NotificationsListRoot} from '../notifications.styles';
import {NotificationListItem} from './notification-list-item';

interface NotificationsListProps {
  notifications: AppNotification[];
  loading: boolean;
  error: unknown;
  onRetry: VoidFunction;
  onOpenNotificationActions: (event: MouseEvent<HTMLElement>, id: string) => void;
  onOpenNotificationDetails: (id: string) => void;
}

export const NotificationsList = ({
  notifications,
  loading,
  error,
  onRetry,
  onOpenNotificationActions,
  onOpenNotificationDetails,
}: NotificationsListProps) => {
  if (loading && !notifications.length) {
    return (
      <NotificationsListRoot alignItems="center" justifyContent="center" gap={1.5}>
        <CircularProgress size={24} />
        <EmptyText>Загрузка уведомлений...</EmptyText>
      </NotificationsListRoot>
    );
  }

  if (error && !notifications.length) {
    return (
      <NotificationsListRoot alignItems="center" justifyContent="center" gap={1}>
        <EmptyText>Не удалось загрузить уведомления</EmptyText>
        <Button size="small" onClick={onRetry}>
          Повторить
        </Button>
      </NotificationsListRoot>
    );
  }

  return (
    <NotificationsListRoot>
      {notifications.length ? (
        notifications.map((notification) => (
          <NotificationListItem
            key={notification.id}
            notification={notification}
            onOpenActions={onOpenNotificationActions}
            onOpenDetails={onOpenNotificationDetails}
          />
        ))
      ) : (
        <NotificationsListRoot alignItems="center" justifyContent="center">
          <EmptyText>Нет уведомлений</EmptyText>
        </NotificationsListRoot>
      )}
    </NotificationsListRoot>
  );
};
